import * as React from 'react';
import i18next from 'i18next';

import ArrayString, { ArrayStringTableCellTypes } from '../components/UI/tableCellTypes/ArrayString/ArrayString';
import Image, { ImageTableCellTypes } from '../components/UI/tableCellTypes/Image/Image';
import FinalMark, { FinalMarkTableCellTypes } from '../components/UI/tableCellTypes/FinalMark/FinalMark';
import Translation from '../components/UI/Translation';
import MarksArray, { PartialMarksArrayTableCellTypes } from '../components/UI/tableCellTypes/MarksArray/MarksArray';
import NoCollapseArrayString from '../components/UI/tableCellTypes/NoCollapseArrayString/NoCollapseArrayString';
import Hour from '../components/UI/tableCellTypes/Hour';

export type AllTableCellTypes =
  | ArrayStringTableCellTypes
  | ImageTableCellTypes
  | FinalMarkTableCellTypes
  | PartialMarksArrayTableCellTypes
  | any;

/**
 * Klasa dostarczająca funkcję generującą odpowiedni komponent na podstawie typu danych
 *
 */
class TableCellTypes {
  public generate = (params: AllTableCellTypes, refreshCallback: any = () => {}): React.ReactNode => {
    const { type, data, row, tab } = params;
    switch (type) {
      case 'image':
        return <Image data={data} />;
      case 'stringArray':
        return <ArrayString data={data} />;
      case 'text':
        return data;
      case 'hour':
        return <Hour timestamp={data} />;
      case 'number':
        return data;
      case 'final_mark':
        return <FinalMark value={data} row={row} tab={tab} refreshCallback={refreshCallback} />;
      case 'partial_marks':
        return <MarksArray value={data} row={row} tab={tab} refreshCallback={refreshCallback} />;
      case 'noCollapseStringArray':
        return <NoCollapseArrayString data={data} />;
      case 'sign':
        return this.generateSignTranslate(data);
      default:
        return <Translation id='WRONG_DATA_FORMAT_INFO' />;
    }
  };
  public generateTableContent = (
    tableData: SingleObjectDataStructure[],
    columns: SingleColumn[],
  ): SingleObjectDataStructure[] => {
    return tableData.map(item => {
      const modifiedItem = { ...item };
      Object.entries(modifiedItem).forEach(([key, value]) => {
        if (value !== null) {
          columns.forEach(col => {
            if (col.dataIndex === key) {
              modifiedItem[key] = this.generate({ type: col.type, data: value });
            }
          });
        }
      });
      return modifiedItem;
    });
  };

  public generateTableKeys = (tableData: SingleObjectDataStructure[]): SingleObjectDataStructure[] =>
    tableData.map((item: any, index: any) => (item['key'] = index));

  // * INFO: sorting requires a string, jsx does not work in this case
  private generateSignTranslate = (data: string) =>
    data === '-1' ? i18next.t('YES') : data === '1' ? i18next.t('IN_PROGRESS_GENERATE_PROTOCOL') : i18next.t('NO');
}

export default new TableCellTypes();
